import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { NavMenuItem } from '../../interfaces/Settings/NavMenuItem';

export const useClickMenuItem = () => {
  const navigate = useNavigate();

  return useCallback((menuItem: NavMenuItem) => {
    switch (menuItem.type) {
      case 'category': {
        navigate(`/kategori/${menuItem.url}`);
        break;
      }
      case 'page': {
        navigate(`/sayfa/${menuItem.url}`);
        break;
      }
      default: {
        const isAbsoluteUrl = /^https?:\/\//i.test(menuItem.url);
        if (isAbsoluteUrl) {
          window.open(menuItem.url, '_blank');
        } else {
          navigate(menuItem.url); // Relative path
        }
        break;
      }
    }
  }, []);
};
